import { featureItems } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-10 md:py-14 bg-background-100/60">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2 text-center">平台优势</h2>
          <p className="text-sm text-foreground-500 mb-8 text-center">为什么选择妖精动漫作为你的漫画阅读平台</p>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {featureItems.map((item, i) => (
              <div
                key={i}
                className="group p-5 md:p-6 bg-background-50 border border-background-200/70 rounded-xl text-center hover:border-primary-200 transition-all duration-300"
              >
                <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-xl bg-primary-100/70 text-primary-500 text-2xl">
                  <i className={item.icon} />
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">{item.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}